var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thiết lập lý do xin nghỉ",
        visible: _vm.dialogVisible,
        width: "780px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "reason-config-wrapper",
        },
        [
          _c("div", { staticClass: "reason-header" }, [
            _c("span", { staticClass: "reason-count" }, [
              _vm._v("Tổng: " + _vm._s(_vm.reasons.length) + " lý do"),
            ]),
            _c(
              "div",
              { staticClass: "reason-header-right" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                      disabled: _vm.customReasonCount >= 20,
                    },
                    on: { click: _vm.openCreateForm },
                  },
                  [_vm._v("\n          Thêm lý do mới\n        ")]
                ),
              ],
              1
            ),
          ]),
          _vm.customReasonCount >= 20
            ? _c("div", { staticClass: "limit-warning" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _vm._v(" Đã đạt giới hạn tối đa 20 lý do tùy chỉnh\n    "),
              ])
            : _vm._e(),
          _c("transition", { attrs: { name: "el-fade-in" } }, [
            _vm.formVisible
              ? _c(
                  "div",
                  { staticClass: "reason-form-card" },
                  [
                    _c("p", { staticClass: "form-title" }, [
                      _vm._v("Thêm lý do mới"),
                    ]),
                    _c(
                      "el-form",
                      {
                        ref: "reasonForm",
                        attrs: {
                          model: _vm.form,
                          rules: _vm.formRules,
                          "label-position": "top",
                          size: "small",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "Tên lý do", prop: "displayName" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "Nhập tên lý do (1-100 ký tự)",
                                maxlength: 100,
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.displayName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "displayName", $$v)
                                },
                                expression: "form.displayName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Nội dung gợi ý",
                              prop: "suggestedContent",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 2,
                                placeholder:
                                  "Nội dung tự động điền khi phụ huynh chọn lý do này (tối đa 500 ký tự)",
                                maxlength: 500,
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.suggestedContent,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "suggestedContent", $$v)
                                },
                                expression: "form.suggestedContent",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.cancelForm },
                              },
                              [_vm._v("Huỷ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  loading: _vm.formLoading,
                                },
                                on: { click: _vm.submitCreateForm },
                              },
                              [_vm._v("\n              Thêm mới\n            ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "transition-group",
            {
              staticClass: "reason-list",
              attrs: { name: "reason-move", tag: "div" },
            },
            _vm._l(_vm.reasons, function (item, index) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "reason-item",
                  class: {
                    "is-disabled": !item.enabled,
                    "is-highlighted": _vm.highlightedId === item.id,
                  },
                },
                [
                  _c("div", { staticClass: "reason-order" }, [
                    _c("span", { staticClass: "order-badge" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "order-buttons" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Di chuyển lên",
                              placement: "top",
                              "open-delay": 400,
                            },
                          },
                          [
                            index > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "order-arrow-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveUp(index)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-caret-top",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Di chuyển xuống",
                              placement: "bottom",
                              "open-delay": 400,
                            },
                          },
                          [
                            index < _vm.reasons.length - 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "order-arrow-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveDown(index)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-caret-bottom",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "reason-toggle" },
                    [
                      _c("el-switch", {
                        attrs: { "active-color": "#67C23A" },
                        model: {
                          value: item.enabled,
                          callback: function ($$v) {
                            _vm.$set(item, "enabled", $$v)
                          },
                          expression: "item.enabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "reason-info" },
                    [
                      _c(
                        "div",
                        { staticClass: "reason-name-row" },
                        [
                          item.isSystemReason
                            ? _c("span", { staticClass: "reason-name-text" }, [
                                _vm._v(_vm._s(item.displayName)),
                              ])
                            : _c("el-input", {
                                staticClass: "inline-name-input",
                                attrs: {
                                  size: "mini",
                                  placeholder: "Tên lý do",
                                  maxlength: 100,
                                },
                                model: {
                                  value: item.displayName,
                                  callback: function ($$v) {
                                    _vm.$set(item, "displayName", $$v)
                                  },
                                  expression: "item.displayName",
                                },
                              }),
                          _c(
                            "el-tag",
                            {
                              staticClass: "reason-type-badge",
                              attrs: {
                                type: item.isSystemReason ? "" : "warning",
                                size: "mini",
                                effect: "plain",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.isSystemReason
                                      ? "Hệ thống"
                                      : "Tùy chỉnh"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticClass: "inline-suggestion-input",
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 1, maxRows: 3 },
                          size: "mini",
                          placeholder: "Nhập nội dung gợi ý...",
                          maxlength: 500,
                        },
                        model: {
                          value: item.suggestedContent,
                          callback: function ($$v) {
                            _vm.$set(item, "suggestedContent", $$v)
                          },
                          expression: "item.suggestedContent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "reason-actions" },
                    [
                      !item.isSystemReason
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btn-delete",
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(item)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-delete" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
          _vm.reasons.length === 0 && !_vm.loading
            ? _c("div", { staticClass: "empty-state" }, [
                _c("i", { staticClass: "el-icon-folder-opened" }),
                _c("p", [_vm._v("Không có dữ liệu")]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: { click: _vm.closeDialog },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _vm._v(" Đóng\n    "),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", size: "medium", loading: _vm.saving },
              on: { click: _vm.saveAll },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _vm._v(" Lưu tất cả\n    "),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }